/* eslint-disable @typescript-eslint/no-explicit-any */
import { ONE_PAGE_LENGTH } from '../constants/pagination';
import { convertToFavoriteEntityType } from './favoriteEntity';
import { EEntityType } from '../types/filters';
import { IFavoriteEntity } from '../types/results';

export enum EOfferType {
  JK = 'JK',
  Offer = 'offer',
}

export interface IProduct {
  id: number;
  offerType: EOfferType;
  position: number;
  published?: boolean;
  // tslint:disable-next-line:no-any
  extra?: any;
}

export function getProduct(entityId: number, favoriteEntities: IFavoriteEntity[]): IProduct {
  let position = 1;
  let favoriteEntity;

  for (let i = 0; i < favoriteEntities.length; i++) {
    if (favoriteEntities[i].entityId === entityId) {
      favoriteEntity = favoriteEntities[i];
      position = i + 1;

      break;
    }
  }

  const isJk = favoriteEntity ? favoriteEntity.jkInfo : false;

  /**
   * Объект products для карточки ЖК
   */
  if (isJk) {
    return {
      id: entityId,
      offerType: EOfferType.JK,
      position,
    };
  }

  /**
   * Объект products для карточки объявления
   */
  return {
    id: entityId,
    offerType: EOfferType.Offer,
    position,
    published: favoriteEntity ? favoriteEntity.status === 'published' : false,
  };
}

export interface IGetAllProductsParams {
  favoriteEntities: IFavoriteEntity[];
  pageNumber?: number;
  skipCount?: number;
}

export function getAllProducs(params: IGetAllProductsParams): IProduct[] {
  const { favoriteEntities, pageNumber, skipCount } = params;

  let favorites = favoriteEntities;

  if (pageNumber && pageNumber > 1 && skipCount) {
    favorites = favoriteEntities.slice(-skipCount);
  }

  return favorites.map(favoriteEntity => {
    const i = favoriteEntities.findIndex(favorite => favoriteEntity.entityId === favorite.entityId);
    const position = i ? i + 1 : 1;

    if (favoriteEntity.jkInfo) {
      return {
        id: favoriteEntity.entityId,
        offerType: EOfferType.JK,
        position,
      };
    }

    return {
      id: favoriteEntity.entityId,
      offerType: EOfferType.Offer,
      position,
      published: favoriteEntity.status === 'published',
    };
  });
}

export function getCustomUrl(favoriteEntity: IFavoriteEntity): string {
  const { dealType, entityId, entityType } = favoriteEntity;

  return `/${dealType}/${convertToFavoriteEntityType(
    (entityType as unknown) as EEntityType,
  ).toLowerCase()}/${entityId}/`;
}

export function getPageNumber(total: number, position: number): number {
  const totalPages = Math.ceil(total / ONE_PAGE_LENGTH);
  let page = 1;

  for (let i = 1; i <= totalPages; i++) {
    if (position <= ONE_PAGE_LENGTH * i) {
      page = i;

      break;
    }
  }

  return page;
}
